import React from "react";
import Navbar from "./Navbar";
import { Link } from "react-router-dom";

const Video = () => {
  console.log("video");
  return (
    <video autoPlay id="video-bg" loop preload="auto" muted={true}>
      <source
        src="https://s3.amazonaws.com/eastgate-file-hosting/videos/nyc-night.mp4"
        type="video/mp4"
      />
    </video>
  );
};

class Homepage extends React.Component {
  constructor() {
    super();

    this.state = {
      width: window.innerWidth,
      setVideo: false
    };
  }

  handleResize = e => {
    const windowSize = window.innerWidth;

    this.setState(prevState => {
      return {
        width: windowSize
      };
    });
  };

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  render() {
    return (
      <div className="homepage">
        <Navbar />
        <div id="bg_overlay" />
        <div className="video-container">
          {this.state.width > 767 && <Video />}
          <img
            className="video_poster"
            src={`${process.env.PUBLIC_URL}/images/nycbg.jpg`}
          />
        </div>
        <div id="wrapper">
          <div id="page">
            <div id="content_container">
              <div className="center" id="content">
                <h1>
                  Unlocking value in underutilized
                  <br />
                  real estate.
                  <br />
                </h1>
                <Link className="btn btn-info" to="/about">
                  Learn More
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Homepage;
